import React, { type ReactNode } from 'react';
import classNames from 'classnames';

interface FilterTopbarProps {
  children?: ReactNode;
  className?: string;
}

export const FilterTopbar = ({
  children,
  className,
}: FilterTopbarProps) => {
  const barClass = classNames(['bg-white p-3 border-bottom', className]);

  return <div className={barClass}>{children}</div>;
};

export default FilterTopbar;
